/** What the element showed when its width was last settled. */
export interface WidthTransitionSnapshot {
  readonly contentKey: string;
  readonly resetKey: string;
}

/**
 * Ease only when the content changes under the same reset key: never on the
 * first render, and never when the reset key (such as the model) changes.
 */
export function shouldTransitionWidth(
  previous: WidthTransitionSnapshot | null,
  next: WidthTransitionSnapshot,
): boolean {
  return (
    previous !== null &&
    previous.resetKey === next.resetKey &&
    previous.contentKey !== next.contentKey
  );
}

/**
 * Reduced motion keeps the ease, only shorter: it is a small width change
 * beside the send button, not motion across the screen.
 */
export function widthTransitionDurationMs(reducedMotion: boolean): number {
  return reducedMotion ? 120 : 180;
}
